<template>
  <div class="row">
    <div
      v-if="combinations[group].supplierCheck && postcodeQuery"
      class="col-md-12"
    >
      <div
        class="alert alert-warning"
        id="speed-alert"
        role="alert"
        v-if="getSpeed(provider).download && getSpeed(provider).download != ''"
      >
        <p class="mb-0" v-if="getSpeed(provider).upload">
          {{
            sprintf(
              translate[lang]["internetspeedinfoup"],
              getSpeed(provider).download,
              getSpeed(provider).upload
            )
          }}
        </p>
        <p class="mb-0" v-else>
          {{
            sprintf(
              translate[lang]["internetspeedinfo"],
              getSpeed(provider).download
            )
          }}
        </p>
      </div>
    </div>

    <div class="col-md-4 mb-3" v-for="item in providers" :key="item.id">
      <div>
        <div
          v-if="!combinations[group].supplierCheck"
          class="custom-control custom-block custom-control-primary"
        >
          <input type="hidden" :value="item.supplier_id" />
          <input
            :id="item.id"
            type="radio"
            class="custom-control-input"
            v-model="provider"
            :name="'products[' + group + '][supplier_id]'"
            :value="item.supplier_id"
            :checked="provider === item.supplier_id"
          />
          <label class="custom-control-label" :for="item.id">
            <span class="d-flex align-items-center">
              <img height="30" :src="getImage(item.logo)" alt />
              <span class="ml-2">
                <span class="font-w700">{{ item.title }}</span>
              </span>
            </span>
          </label>
          <span
            class="custom-block-indicator"
            v-if="provider === item.supplier_id"
          >
            <i class="fa fa-check"></i>
          </span>
        </div>
        <div
          class="custom-control custom-block custom-control-danger bg-transparent opacity-50"
          v-else-if="item.available !== 0"
          v-b-popover.hover.top="{
            title: 'Error',
            content: getSpeed(item.supplier_id).error,
            html: true,
            disabled: typeof getSpeed(item.supplier_id).error != 'string'
            // || getSpeed(item.supplier_id).error.includes('undefined'),
          }"
        >
          <input type="hidden" :value="item.supplier_id" />
          <input
            :id="item.id"
            type="radio"
            class="custom-control-input"
            value="1"
            v-model="test"
            disabled
            :checked="true"
          />
          <label class="custom-control-label" :for="item.id">
            <span class="d-flex align-items-center">
              <img height="30" :src="getImage(item.logo)" alt />
              <span class="ml-2">
                <span class="font-w700">{{ item.title }}</span>
              </span>
              <div
                v-if="
                  postcodeQuery &&
                    !postcodeQuery.error &&
                    !(
                      itemIsShow.filter(a => a.id == item.supplier_id)[0] &&
                      itemIsShow.filter(a => a.id == item.supplier_id)[0]
                        .isShow === false
                    )
                "
                class="spinner-border text-primary"
                role="status"
                style="width: 20px; height: 20px; margin-left: 5px"
              ></div>
            </span>
          </label>
          <span class="custom-block-indicator">
            <i class="fas fa-info"></i>
          </span>
          <!-- <p>1</p> -->
        </div>
        <div
          class="custom-control custom-block custom-control-primary"
          v-else-if="item.show === 0 && postcodeQuery && !postcodeQuery.error"
        >
          <input type="hidden" :value="item.supplier_id" />
          <input
            :id="item.id"
            type="radio"
            class="custom-control-input"
            v-model="provider"
            :value="item.supplier_id"
          />
          <label class="custom-control-label" :for="item.id">
            <span class="d-flex align-items-center">
              <img height="30" :src="getImage(item.logo)" alt />
              <span class="ml-2">
                <span class="font-w700">{{ item.title }}</span>
              </span>
            </span>
          </label>
          <span
            class="custom-block-indicator"
            v-if="provider === item.supplier_id"
          >
            <i class="fa fa-check"></i>
          </span>
          <!-- <p>2</p> -->
        </div>
        <div
          class="custom-control custom-block custom-control-primary"
          v-else-if="item.show === 1 && postcodeQuery && !postcodeQuery.error"
        >
          <input
            type="hidden"
            :name="'products[' + group + '][supplier_id]'"
            :value="item.supplier_id"
          />
          <input
            :id="item.id"
            type="radio"
            class="custom-control-input"
            v-model="provider"
            :value="item.supplier_id"
          />
          <label class="custom-control-label" :for="item.id">
            <span class="d-flex align-items-center">
              <img height="30" :src="getImage(item.logo)" alt />
              <span class="ml-2">
                <span class="font-w700">{{ item.title }}</span>
              </span>
            </span>
          </label>
          <span
            class="custom-block-indicator"
            v-if="provider === item.supplier_id"
          >
            <i class="fa fa-check"></i>
          </span>
          <!-- <p>3</p> -->
        </div>
        <div
          class="custom-control custom-block custom-control-danger bg-transparent opacity-50"
          v-else
        >
          <input type="hidden" :value="item.supplier_id" />
          <input
            :id="item.id"
            type="radio"
            class="custom-control-input"
            value="1"
            v-model="test"
            disabled
            :checked="true"
          />
          <label class="custom-control-label" :for="item.id">
            <span class="d-flex align-items-center">
              <img height="30" :src="getImage(item.logo)" alt />
              <span class="ml-2">
                <span class="font-w700">{{ item.title }}</span>
              </span>
              <div
                v-if="
                  postcodeQuery &&
                    !postcodeQuery.error &&
                    !(
                      itemIsShow.filter(a => a.id == item.supplier_id)[0] &&
                      itemIsShow.filter(a => a.id == item.supplier_id)[0]
                        .isShow === false
                    )
                "
                class="spinner-border text-primary"
                role="status"
                style="width: 20px; height: 20px; margin-left: 5px"
              ></div>
            </span>
          </label>
          <span class="custom-block-indicator">
            <i class="fa fa-times-circle"></i>
          </span>
          <!-- <p>4</p> -->
        </div>
      </div>
    </div>
    <div
      class="col-md-12"
      v-if="combinations[group].supplierCheck && !postcodeQuery"
    >
      <div
        class="alert alert-danger"
        style="cursor: pointer"
        role="alert"
        @click="scrollAnimate('#addressBlock')"
      >
        <p class="mb-0">{{ translate[lang]["addresscheck"] }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
//import $ from "jquery"
export default {
  name: "Providers",
  props: ["group"],
  data() {
    return {
      test: 1,
      provider: 0,
      providers: [],
      providersList: []
    };
  },
  computed: {
    ...mapState({
      checkZiggo: state => state.forms.checkZiggo,
      checkTmobile: state => state.forms.checkTmobile,
      checkYoufone: state => state.forms.checkYoufone,
      checkKpn: state => state.forms.checkKpn,
      combinations: state => state.forms.combinations,
      itemIsShow: state => state.forms.itemIsShow
    }),
    speed() {
      return this.getGroupArray(this.group).filter(
        item => item.type === "suppliers"
      )[0].speed;
    }
  },
  created() {
    this.providers = this.uniqueArray(
      this.getGroupArray(this.group).filter(
        item => item.type === "suppliers"
      )[0].suppliers,
      "title"
    );
    this.providersList = this.getGroupArray(this.group).filter(
      item => item.type === "suppliers"
    )[0];
    this.provider = this.getGroupArray(this.group).filter(
      item => item.type === "suppliers"
    )[0].groupDefault;
  },
  methods: {
    getSpeed(supplier_id) {
      let returnObject = {};
      if (this.checkYoufone && this.checkYoufone.supplier_id == supplier_id) {
        this.checkYoufone.speed
          ? (returnObject = {
              download: parseFloat(this.checkYoufone.speed.orderable),
              upload: parseFloat(this.checkYoufone.speed.upload)
            })
          : (returnObject = {
              error: this.checkYoufone.error
            });
      }

      if (this.checkZiggo && this.checkZiggo.supplier_id == supplier_id) {
        this.checkZiggo.speed
          ? (returnObject = {
              download: parseFloat(this.checkZiggo.speed.orderable),
              upload: parseFloat(this.checkZiggo.speed.upload)
            })
          : (returnObject = {
              error: this.checkZiggo.error
            });
      }

      if (this.checkTmobile && this.checkTmobile.supplier_id == supplier_id) {
        this.checkTmobile.speed
          ? (returnObject = {
              download: parseFloat(this.checkTmobile.speed.orderable),
              upload: parseFloat(this.checkTmobile.speed.upload)
            })
          : (returnObject = {
              error: this.checkTmobile.error
            });
      }

      if (this.checkKpn && this.checkKpn.supplier_id == supplier_id) {
        this.checkKpn.speed
          ? (returnObject = {
              download: parseFloat(this.checkKpn.speed.orderable),
              upload: parseFloat(this.checkKpn.speed.upload)
            })
          : (returnObject = {
              error: this.checkKpn.error
            });
      }

      if (returnObject.error && Array.isArray(returnObject.error)) {
        let error_message_string = "";
        returnObject.error.forEach(msg => {
          error_message_string += `&bull; ${msg} <br>`;
        });
        returnObject.error = error_message_string;
      }
      return returnObject;
    },
    refreshSupplier() {
      this.suppliersVisible(this.providersList.suppliers, 2);
      this.providersList.animate = 0;
      this.providersList.suppliers.forEach(item => {
        item.show = 0;
        if (item.supplier_id === this.provider) {
          item.show = 1;
        }
      });
      this.getGroupArray(this.group).filter(
        item => item.type === "suppliers"
      )[0].groupDefault = this.provider;
      this.setOverview();
    }
  },
  watch: {
    provider: {
      handler: function() {
        this.refreshSupplier();
      }
    },
    speed() {
      this.refreshSupplier();
    }
  }
};
</script>

<style scoped></style>
